import { combineReducers } from "redux";

import order from "./order";
import route from "./route";
import quote from "./quote";
import costProvider from "./costProvider";
import invoice from "./invoice";
import payment from "./payment";
import clientsRoute from "./clientsRoutes";
import providersRoutes from "./providersRoute";
import paymentClient from "./paymentClients";
import addTemporalDP from "./addTemporalDP";
import deliveryPointRoute from "./deliveyPointRoute";
import invoiceProvider from "./invoiceProvider";
import home from "./home";
import file from "./filesRoute";
import newRoute from "./importRoute";
import fileDeliveryPoint from "./filesDeliveryPoint"

export default combineReducers({
  order,
  route,
  quote,
  costProvider,
  invoice,
  payment,
  clientsRoute,
  providersRoutes,
  paymentClient,
  addTemporalDP,
  deliveryPointRoute,
  invoiceProvider,
  file,
  home,
  newRoute,
  fileDeliveryPoint
});
